import { IDocumentLinksTable } from '@models/Forms/IForms';
import './LinksTable.scss';
import { TableTab } from '@models/document/IDocumentScheme';
import DocumentLinksTable from '@organisms/document/DocumentTabBuilder/tabs/DocumentTabLinks/DocumentLinksTable';

export interface ILinksTableProps {
    table: IDocumentLinksTable;
    tables: TableTab[];
    docId?: string;
}

const LinksTable = ({ table, tables, docId }: ILinksTableProps) => {
    const linkTable = tables.find((t) => t.key === table.key);

    return table && table.key && linkTable ? (
        <DocumentLinksTable linkId={table.id} linkTable={linkTable} docId={docId} />
    ) : (
        <></>
    );
};

export default LinksTable;
